export const isValidFormattedPrice = (value: string) => {
  if (value === '0') {
    return { formattedPrice: value, isValid: true };
  }
  const formattedPrice = value.replace(/,/g, '').replace(/^0+/, '');
  const isValid = /^\d*$/.test(formattedPrice);
  return { formattedPrice, isValid };
};
